// @flow

export const minBreakPointRaw = (bp: string): string => `(min-width: ${bp}px)`;

export const minBreakPoint = (bp: string): string =>
  `@media screen and ${minBreakPointRaw(bp)}`;

export const breakPoint = minBreakPoint;

type Theme = { units: { baseUnit: number } };

export const renderUnitSize = (theme: Theme, size: number): string =>
  `${theme.units.baseUnit * size}rem`;

export const sizeShortHandGenerator = (property: string) => (
  theme: Theme,
  size: number | number[],
): string => {
  if (typeof size === 'number') {
    return `${property}: ${renderUnitSize(theme, size)}`;
  } else if (Array.isArray(size)) {
    return `${property}: ${size.map(s => renderUnitSize(theme, s)).join(' ')}`;
  } else {
    return '';
  }
};



// WEBPACK FOOTER //
// ./src/helpers/styleHelpers.js